import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NewReferral } from '@models/partner/client-setup/partner-client-setup';
import { AtlasToastService } from '@services/atlas-toast.service';
import { PartnerClientSetUpService } from '@services/partner-clientsetup.service';
import { AtlasInputPhoneComponent } from '@ui/components/atlas-inputphone/atlas-inputphone.component';
import { ToastContainerDirective } from 'ngx-toastr';
@Component({
  selector: 'wsb-partner-clientsetup-newreferral',
  templateUrl: './partner-clientsetup-newreferral.component.html',
  styleUrls: ['./partner-clientsetup-newreferral.component.scss'],
  standalone: false
})
export class PartnerNewReferralComponent implements OnInit, AfterViewChecked {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @ViewChild(AtlasInputPhoneComponent) inputPhone: AtlasInputPhoneComponent;
  @ViewChild('page') $page;
  $actionsBar: ElementRef;
  @ViewChild('actionsBar') set content(content: ElementRef) {
    if (content) {
      this.$actionsBar = content;
    }
  }
  newReferralFrom: UntypedFormGroup = null;

  constructor(
    private clientSetUpService: PartnerClientSetUpService,
    private formBuilder: UntypedFormBuilder,
    private elRef: ElementRef,
    private atlasToast: AtlasToastService
  ) {}

  ngOnInit(): void {
    window.addEventListener('scroll', this.scroll, true);

    this.newReferralFrom = this.formBuilder.group({
      companyName: ['', [Validators.required]],
      registrationEmail: ['', [Validators.email]],
      name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^(\+)?[0-9]{5,15}$/)]]
    });
  }

  ngAfterViewChecked(): void {
    this.displayScrollIndicator();
  }

  scroll = (): void => {
    this.displayScrollIndicator();
  };

  onSubmit() {
    this.newReferralFrom.disable();
    const newRafferal: NewReferral = this.newReferralFrom.getRawValue();
    this.clientSetUpService.createReferral(newRafferal).subscribe(
      success => {
        this.atlasToast.success('common_success', null, 6000, this.toastContainer);
        this.onResetForm();
        this.newReferralFrom.enable();
      },
      error => {
        this.atlasToast.error('common_error', null, 6000, this.toastContainer);
        this.newReferralFrom.enable();
      }
    );
  }

  onResetForm() {
    this.newReferralFrom.reset();
    this.inputPhone.phoneNumber.setValue(null);
  }

  private displayScrollIndicator() {
    if (!(this.$page && this.$actionsBar)) {
      return;
    }
    const $pageAccount: HTMLElement = this.$page.nativeElement;
    const $actionsBar: HTMLElement = this.$actionsBar.nativeElement;
    const $impersonateHeader: HTMLElement = document.getElementById('impersonate-header');

    if (!this.elRef.nativeElement || !this.elRef.nativeElement.closest('body')) {
      return;
    }

    const remainingHeight = window.innerHeight - $pageAccount.getBoundingClientRect().top;

    if (
      $pageAccount.clientHeight > remainingHeight + 5 &&
      $pageAccount.getBoundingClientRect().bottom - window.innerHeight - $impersonateHeader.getBoundingClientRect().bottom > 50
    ) {
      $actionsBar.classList.add('has--scroll-indicator');
    } else {
      $actionsBar.classList.remove('has--scroll-indicator');
    }
  }
}
